import { Country } from './country.model';

export const countries: Country[] = [
  {
    ID: 1,
    Code: 'US',
    Name: 'United States',
    Description: 'The United States of America',
    IsEuropean: false,
  },
  {
    ID: 2,
    Code: 'GB',
    Name: 'United Kingdom',
    Description: 'The United Kingdom of Great Britain and Northern Ireland',
    IsEuropean: true,
  },
  {
    ID: 3,
    Code: 'FR',
    Name: 'France',
    Description: 'The French Republic',
    IsEuropean: true,
  },
  {
    ID: 4,
    Code: 'DE',
    Name: 'Germany',
    Description: 'The Federal Republic of Germany',
    IsEuropean: true,
  },
  {
    ID: 5,
    Code: 'CA',
    Name: 'Canada',
    Description: 'Canada',
    IsEuropean: false,
  },
  {
    ID: 6,
    Code: 'IT',
    Name: 'Italy',
    Description: 'The Italian Republic',
    IsEuropean: true,
  },
  {
    ID: 7,
    Code: 'JP',
    Name: 'Japan',
    Description: 'Japan',
    IsEuropean: false,
  },
  {
    ID: 8,
    Code: 'AU',
    Name: 'Australia',
    Description: 'The Commonwealth of Australia',
    IsEuropean: false,
  },
  {
    ID: 9,
    Code: 'BR',
    Name: 'Brazil',
    Description: 'The Federative Republic of Brazil',
    IsEuropean: false,
  },
  {
    ID: 10,
    Code: 'ES',
    Name: 'Spain',
    Description: 'The Kingdom of Spain',
    IsEuropean: true,
  },
  {
    ID: 11,
    Code: 'MX',
    Name: 'Mexico',
    Description: 'The United Mexican States',
    IsEuropean: false,
  },
  {
    ID: 12,
    Code: 'RU',
    Name: 'Russia',
    Description: 'The Russian Federation',
    IsEuropean: false,
  },
  {
    ID: 13,
    Code: 'KR',
    Name: 'South Korea',
    Description: 'The Republic of Korea',
    IsEuropean: false,
  },
  {
    ID: 14,
    Code: 'NL',
    Name: 'Netherlands',
    Description: 'The Kingdom of the Netherlands',
    IsEuropean: true,
  },
  {
    ID: 15,
    Code: 'CH',
    Name: 'Switzerland',
    Description: 'The Swiss Confederation',
    IsEuropean: true,
  },
  {
    ID: 16,
    Code: 'SA',
    Name: 'Saudi Arabia',
    Description: 'The Kingdom of Saudi Arabia',
    IsEuropean: false,
  },
  {
    ID: 17,
    Code: 'TR',
    Name: 'Turkey',
    Description: 'The Republic of Turkey',
    IsEuropean: false,
  },
  {
    ID: 18,
    Code: 'SE',
    Name: 'Sweden',
    Description: 'The Kingdom of Sweden',
    IsEuropean: true,
  },
  {
    ID: 19,
    Code: 'BE',
    Name: 'Belgium',
    Description: 'The Kingdom of Belgium',
    IsEuropean: true,
  },
  {
    ID: 20,
    Code: 'AT',
    Name: 'Austria',
    Description: 'The Republic of Austria',
    IsEuropean: true,
  },
  {
    ID: 21,
    Code: 'NO',
    Name: 'Norway',
    Description: 'The Kingdom of Norway',
    IsEuropean: true,
  },
  {
    ID: 22,
    Code: 'IR',
    Name: 'Iran',
    Description: 'The Islamic Republic of Iran',
    IsEuropean: false,
  },
  {
    ID: 23,
    Code: 'AE',
    Name: 'United Arab Emirates',
    Description: 'The United Arab Emirates',
    IsEuropean: false,
  },
  {
    ID: 24,
    Code: 'PL',
    Name: 'Poland',
    Description: 'The Republic of Poland',
    IsEuropean: true,
  },
  {
    ID: 25,
    Code: 'ZA',
    Name: 'South Africa',
    Description: 'The Republic of South Africa',
    IsEuropean: false,
  },
  {
    ID: 26,
    Code: 'SG',
    Name: 'Singapore',
    Description: 'The Republic of Singapore',
    IsEuropean: false,
  },
  {
    ID: 27,
    Code: 'MY',
    Name: 'Malaysia',
    Description: 'Malaysia',
    IsEuropean: false,
  },
  {
    ID: 28,
    Code: 'PT',
    Name: 'Portugal',
    Description: 'The Portuguese Republic',
    IsEuropean: true,
  },
  {
    ID: 29,
    Code: 'TH',
    Name: 'Thailand',
    Description: 'The Kingdom of Thailand',
    IsEuropean: false,
  },
  {
    ID: 30,
    Code: 'EG',
    Name: 'Egypt',
    Description: 'The Arab Republic of Egypt',
    IsEuropean: false,
  },
];
